import Resource from "./resource.js";
export class Ssf extends Resource {
    constructor(client) {
        super(client, {
            path: "/admin/realms/{realm}/ssf",
            getUrlParams: () => ({
                realm: client.realmName,
            }),
            getBaseUrl: () => client.baseUrl,
        });
    }
    getConfig = this.makeRequest({
        method: "GET",
        path: "/config",
    });
    getEventStats = this.makeRequest({
        method: "GET",
        path: "/events/stats",
    });
    deleteEvents = this.makeRequest({
        method: "DELETE",
        path: "/events",
        queryParamKeys: ["status", "olderThan"],
    });
    deleteQueuedEvents = this.makeRequest({
        method: "DELETE",
        path: "/events/queued",
    });
    findClientStream = this.makeRequest({
        method: "GET",
        path: "/clients/{clientId}/stream",
        urlParamKeys: ["clientId"],
        catchNotFound: true,
    });
    createClientStream = this.makeUpdateRequest({
        method: "POST",
        path: "/clients/{clientId}/stream",
        urlParamKeys: ["clientId"],
    });
    updateClientStream = this.makeUpdateRequest({
        method: "PATCH",
        path: "/clients/{clientId}/stream",
        urlParamKeys: ["clientId"],
    });
    deleteClientStream = this.makeRequest({
        method: "DELETE",
        path: "/clients/{clientId}/stream",
        urlParamKeys: ["clientId"],
    });
    verifyClientStream = this.makeRequest({
        method: "POST",
        path: "/clients/{clientId}/stream/verify",
        urlParamKeys: ["clientId"],
    });
    updateClientStreamStatus = this.makeUpdateRequest({
        method: "POST",
        path: "/clients/{clientId}/stream/status",
        urlParamKeys: ["clientId"],
    });
    addSubject = this.makeUpdateRequest({
        method: "POST",
        path: "/clients/{clientId}/subjects/add",
        urlParamKeys: ["clientId"],
    });
    removeSubject = this.makeUpdateRequest({
        method: "POST",
        path: "/clients/{clientId}/subjects/remove",
        urlParamKeys: ["clientId"],
    });
    ignoreSubject = this.makeUpdateRequest({
        method: "POST",
        path: "/clients/{clientId}/subjects/ignore",
        urlParamKeys: ["clientId"],
    });
    checkSubject = this.makeUpdateRequest({
        method: "POST",
        path: "/clients/{clientId}/subjects/check",
        urlParamKeys: ["clientId"],
        catchNotFound: true,
    });
    emitEvent = this.makeUpdateRequest({
        method: "POST",
        path: "/clients/{clientId}/events/emit",
        urlParamKeys: ["clientId"],
    });
    findPendingEvent = this.makeRequest({
        method: "GET",
        path: "/clients/{clientId}/pending-events/{jti}",
        urlParamKeys: ["clientId", "jti"],
        catchNotFound: true,
    });
    getClientEventStats = this.makeRequest({
        method: "GET",
        path: "/clients/{clientId}/events/stats",
        urlParamKeys: ["clientId"],
    });
    deleteClientEvents = this.makeRequest({
        method: "DELETE",
        path: "/clients/{clientId}/events",
        urlParamKeys: ["clientId"],
        queryParamKeys: ["status", "olderThan"],
    });
    deleteClientQueuedEvents = this.makeRequest({
        method: "DELETE",
        path: "/clients/{clientId}/events/queued",
        urlParamKeys: ["clientId"],
    });
}
//# sourceMappingURL=ssf.js.map